import { getBuildingFormSchema } from "web_myplann/Portfolio/Forms/BuildingShared/buildingFormSchema";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import type { z } from "zod";

export const getCottageFormSchema = (t: TranslateFunction) =>
	getBuildingFormSchema(t);

export type CottageFormInput = z.input<ReturnType<typeof getCottageFormSchema>>;
export type CottageFormOutput = z.output<
	ReturnType<typeof getCottageFormSchema>
>;
